type Header = {
  key: string;
  label: string;
  sortable?: boolean;
  style?: React.CSSProperties;
};
export const DoctorList_HEADERS = [
  { label: "Schedule Status", key: "scheduleStatus", style: { width: "18%" } },
  { label: "Date", key: "Date", style: { width: "18%" } },
  { label: "Start Time", key: "startTimeNew", style: { width: "12%" } },
  { label: "End Time", key: "endTimeNew", style: { width: "12%" } },
  { label: "Location", key: "hospital", style: { width: "46%" } },
];
export const ScheduleList_HEADERS = [
  {
    label: "Availability",
    key: "scheduleType",
    style: { width: "20%" },
    sortable: true,
  },
  {
    label: "By Date Range/Month",
    key: "scheduleMode",
    style: { width: "30%" },
    sortable: true,
  },
  {
    label: "Selected Date Range/Month",
    key: "selecteddaterangemonth",
    style: { width: "30%" },
    sortable: true,
  },
  {
    label: "Selected Day(s)",
    key: "selectedays",
    style: { width: "30%" },
    sortable: true,
  },
  {
    label: "Time Slot(s)",
    key: "timeslots",
    style: { width: "25%" },
    sortable: true,
  },
  {
    label: "Location",
    key: "medicareProviderName",
    style: { width: "46%" },
    sortable: true,
  },
  { label: "Action", key: "actions", style: { width: "20%" } },
];

export const ViewHeader: Header[] = [
  {
    key: "patientName",
    label: "Patient Name",
    style: { width: "14%" },
  },
  { key: "doctor", label: "Doctor", style: { width: "14%" } },
  { key: "examType", label: "Exam Type", style: { width: "10%" } },
  {
    key: "location",
    label: "Location",
    style: { width: "15%" },
  },
  {
    key: "time",
    label: "Time",
    style: { width: "10%" },
  },
];

export const APPOINTMENT_LIST_ON_VIEW_SCHEDULE: Header[] = [
  { label: "Patient Name", key: "patientName", style: { width: "20%" } },
  { label: "Doctor", key: "doctorName", style: { width: "20%" } },
  { label: "Exam Type", key: "examType", style: { width: "20%" } },

  { label: "Location", key: "location", style: { width: "20%" } },
  { label: "Date & Time", key: "dateOfAppointment", style: { width: "20%" } },
];
